import type { ReactNode } from 'react';
import { MODULES, PLAN_LABELS, type Plan } from '@kontor/shared';
import { useSession } from '../session';

/**
 * Blendet Seiten aus, für die das Modul nicht lizenziert ist oder das Recht fehlt.
 * Das ist nur Komfort für die Oberfläche: Die eigentliche Prüfung macht der Server bei jedem Aufruf.
 */
export function ModuleGate({ module, permission, children }: { module: string; permission?: string; children: ReactNode }) {
  const { hasModule, can, session } = useSession();
  const label = MODULES.find((m) => m.key === module)?.label ?? module;
  if (!hasModule(module)) {
    return (
      <div className="card narrow">
        <h1>{label}</h1>
        <p className="muted">Dieses Modul ist im Paket {PLAN_LABELS[session?.tenant.plan as Plan] ?? session?.tenant.plan} nicht enthalten. Sprechen Sie uns an, wenn Sie es freischalten möchten.</p>
      </div>
    );
  }
  if (permission && !can(permission)) {
    return (
      <div className="card narrow">
        <h1>{label}</h1>
        <p className="muted">Ihre Rolle hat keinen Zugriff auf diesen Bereich.</p>
      </div>
    );
  }
  return <>{children}</>;
}
